import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import numeral from 'numeral'
import useUserContext from '../../hooks/useUserContext'
import useCountUp from '../../hooks/useCountUp'
import utils from '../../utils/utils'

export const BalanceRealAnimated = () => {
  const initialBalance = utils.getUserBalance()?.balanceReal ?? 0
  const [prevBalance, setPrevBalance] = useState(initialBalance)
  const { userBalance } = useUserContext()

  useEffect(() => {
    if (userBalance?.balanceReal) {
      setPrevBalance(userBalance.balanceReal)
    }
  }, [userBalance])

  const num = useCountUp({
    start: prevBalance,
    end: userBalance?.balanceReal ?? 0,
    duration: 1.4
  })

  const balance = numeral(num / 100).format('$0,000.00')

  return (
    <BalanceContainer>
      <CircleIcon>
        <InnerCircle />
      </CircleIcon>
      <BalanceText>
        <BalanceLabel>Balance real</BalanceLabel>
        <BalanceAmount>{balance} MXN</BalanceAmount>
      </BalanceText>
    </BalanceContainer>
  )
}

const BalanceContainer = styled.div` 
  display: flex;
  align-items: center;
  gap: 16px;
  width: fit-content;
  margin: 0 auto;
  margin-bottom: 25px;
  padding: 0 20px;
`

const CircleIcon = styled.div`
  width: 48px;
  height: 48px;
  background: linear-gradient(to bottom, #79BA1E, #74bb1f);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

const InnerCircle = styled.div`
  width: 30px;
  height: 30px;
  border: 6px solid #ffffff;
  border-radius: 50%;
  background: transparent;
`

const BalanceText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const BalanceLabel = styled.span`
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
`

const BalanceAmount = styled.span`
  color: #79BA1E;
  font-size: 24px;
  font-weight: bold;
`
